import { render, staticRenderFns } from "./ManageTreatmentModal.vue?vue&type=template&id=d86d2736"
import script from "./ManageTreatmentModal.vue?vue&type=script&lang=js"
export * from "./ManageTreatmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports